<ul class="social-links__list">
    <li *ngFor="let item of items" class="social-links__item">
        <a
            class="social-links__link social-links__link--type--{{ item.type }}"
            target="_blank"
            rel="noopener noreferrer"
            [title]="names[item.type] || item.type"
            [attr.aria-label]="names[item.type] || item.type"
            [href]="item.url"
        >
            <!-- The X mark is drawn here rather than added to sprite.svg, which browsers keep for a
                 year under the same url. -->
            <svg *ngIf="item.icon === 'x'" width="17" height="17" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="fill: #fff;">
                <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
            </svg>
            <app-icon *ngIf="item.icon !== 'x'" size="24" [name]="item.icon" style="fill: #fff;"></app-icon>
        </a>
    </li>
</ul>
